<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-26 22:33:18
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 01:39:17
-->
<template>
  <div class="accountant-business">
    <!-- 头部信息 -->
    <HeaderSearch
      :keyWord.sync="keyWord"
      pageName="身份认证审核"
      tip="请输入手机号、姓名查询"
      :dispatchOrder="dispatchOrder"
      @updatekeyWord="updatekeyWord"
      @updataState="updataState"
    ></HeaderSearch>

    <div class="listbox">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          ref="vantlist"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="listitem" v-for="(item, index) in list" :key="index">
            <div class="top">
              <div class="inbox">
                <span>申请时间：{{ item.applyTime }}</span>
                <div class="buttomstyle" @click="goExamine(item.id)">
                  {{ item.approveState == 1 ? "审核" : "查看详情" }}
                </div>
              </div>
            </div>
            <div :class="[state == '' ? 'bottomstyle pingjun' : 'bottomstyle']">
              <div :class="[state == '' ? 'left' : 'left user']">
                <img src="@/assets/dispatch/toExamine/username.png" alt="" />
                <span>{{ item.name }}</span>
              </div>
              <div class="left">
                <img src="@/assets/dispatch/toExamine/acphon.png" alt="" />
                <span>{{ item.phone }}</span>
              </div>
              <div class="left" v-if="state == ''">
                <img
                  class="stateimg"
                  :src="geticon(item.approveState)"
                  alt=""
                />
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import HeaderSearch from "@/components/HeaderSearch";
import dispatchReciveOrder from "./components/dispatchReciveOrder";
import dispatchUnreciveOrder from "./components/dispatchUnreciveOrder";
import { verifylist } from "@/utils/network/toExamine";
export default {
  name: "shipowner",
  components: {
    HeaderSearch,
    dispatchReciveOrder,
    dispatchUnreciveOrder,
  },
  props: {},
  data() {
    return {
      // 顶部搜索框
      keyWord: "",
      // tabs
      dispatchOrder: [
        {
          text: "未审核",
          state: 1,
        },
        {
          text: "已驳回",
          state: 3,
        },
        {
          text: "已通过",
          state: 2,
        },
        {
          text: "全部",
          state: "",
        },
      ],
      state: 1,
      // 下拉刷新
      refreshing: false,
      loading: true,
      finished: true,
      pageNum: 1,
      //列表数据
      list: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getlistmsg();
  },
  methods: {
    updatekeyWord(e) {
      this.keyWord = e;
      this.pageNum = 1;
      this.list = [];
      this.getlistmsg();
    },
    updataState(e) {
      this.state = e;
      this.pageNum = 1;
      this.list = [];
      this.keyWord = "";
      this.loading = true;
      this.getlistmsg();
    },
    // 下拉刷新
    onRefresh() {
      this.finished = false;

      this.loading = true;
      this.pageNum = 1;
      this.list = [];
      this.getlistmsg();
    },
    // 上拉加载下一页
    onLoad() {
      this.getlistmsg();
    },
    // 请求列表数据
    getlistmsg() {
      verifylist({
        approveState: this.state,
        searchValue: this.keyWord,
        pageNum: this.pageNum,
      }).then((res) => {
        console.log(res);
        if (res.pageCount >= this.pageNum) {
          res.rows.filter((v) => {
            this.list.push(v);
          });
          this.loading = false;
          this.finished = false;
          this.refreshing = false;
          this.pageNum++;
          console.log(this.loading, 111);
          console.log(this.$refs.vantlist.loading, "组件中的值");
        } else {
          this.finished = true;
          this.loading = false;
        }
      });
    },
    // 返回图片
    geticon(status) {
      switch (status) {
        case 1:
          return require("@/assets/dispatch/toExamine/Unaudited.png");
        case 2:
          return require("@/assets/dispatch/toExamine/Passed.png");
        case 3:
          return require("@/assets/dispatch/toExamine/Rejected.png");
      }
    },
    goExamine(id) {
      this.$router.push({
        path: "/dispatch/toExamine/identityExamine",
        query: { id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.accountant-business {
  padding-top: 150px;
  height: 100vh;
  background: #eeeeee;

  .listbox {
    padding: 0 16px;
    .listitem {
      border-radius: 5px;
      margin-bottom: 12px;
      .top {
        padding: 11px 12px;
        border-radius: 5px 5px 0 0;
        background: linear-gradient(
          78deg,
          rgba(68, 177, 249, 0.12) 0%,
          #ffffff 100%
        );
        .inbox {
          display: flex;
          opacity: 1;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          font-weight: 400;
          text-align: center;
          color: #666666;
          line-height: 20px;
          .buttomstyle {
            color: #ffffff;
            padding: 4px 15px;
            background: #44b2f9;
            border-radius: 10px;
          }
        }
      }
      .bottomstyle {
        padding: 14px 12px;
        display: flex;
        align-items: center;
        background: #ffffff;
        border-radius: 0 0 5px 5px;
        .left {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          img {
            width: 20px;
            height: 20px;
            margin-right: 6px;
          }
          .stateimg {
            width: 47px;
            height: 20px;
          }
        }
        .user {
          margin-right: 50px;
        }
      }
      .pingjun {
        justify-content: space-between;
      }
    }
  }
}
</style>
import { nextTick } from "vue/types/umd";
